export const basename = '/dashboard';
